import React, { useReducer, useContext, createContext, useEffect, useMemo } from 'react'
import { defaultReducer } from '../Utils/reducers'
import { api } from '../../services/api'
import { Box } from '@mui/material';
import ColorButton from '../Buttons/ColorButton';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { customTheme } from '../theme/textfieldTheme';
import './style.css'
import { externalComponent } from '../AppRoutes'
import { toast } from 'react-hot-toast';
import ExecuteModal from './execute-modal';
import ModalPendency from './modalPendency';
import ModalOrders from './modalOrders';
import clsx from 'clsx';
import { compareDates, formatDate } from './functionsCore';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import Table, { TableHookPro } from '../Table';

export const DistributionContext = createContext()

const getColumnsDistribution = (state) => {
    const columns = []


    columns.push({
        field: 'aro',
        headerName: 'Aro',
        flex: 0.7,
        cellClassName: () => {
            return clsx('default-app bold', {
                selected: true,
            });
        }
    })

    columns.push({
        field: 'medida',
        headerName: 'Medida',
        flex: 0.9,
        align: 'left',
        cellClassName: () => {
            return clsx('default-app bold align-start', {
                selected: true,
            });
        }
    })


    for (let i = 0; i < state.columns.length; i++) {
        const column = state.columns[i];

        let includeColumn = true; // por padrão inclui

        // Só aplica a soma se já houver rows
        if (state.data.length > 0) {
            const total = state.data.reduce((acc, row) => {
                const value = row[column];
                return acc + (typeof value === 'number' ? value : 0);
            }, 0);

            includeColumn = total > 0;
        }

        // Se deve incluir, adiciona ao array de colunas
        if (includeColumn) {
            const isVenda = column.includes("Ven");

            columns.push({
                field: column,
                headerName: column,
                flex: 0.5,
                cellClassName: () => clsx(
                    'default-app',
                    isVenda ? 'ven-tables' : 'est-tables',
                    { selected: true }
                )
            });
        }
    }


    columns.push({
        field: 'dispbks',
        headerName: 'BKS Disp',
        flex: 1.2,
        cellClassName: () => {
            return clsx('default-app dep-bks', {
                selected: true,
            });
        }
    })

    return columns

}

const convertDateFormat = (dateString) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const date = new Date(dateString);

        const formattedDate = date.toISOString().slice(0, 10);

        return formattedDate;
    } else {
        const date = new Date(dateString);

        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

        return formattedDate;
    }
}



const currentDate = new Date();
const threeMonthsAgo = new Date();

threeMonthsAgo.setDate(1);
threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);


var dtFinal = convertDateFormat(currentDate)
var dtInicial = convertDateFormat(threeMonthsAgo)

export const distributionInitialState = {
    renderRow: null, data: [], dataToResetDist: [], dtInicial: dtInicial, dtFinal: dtFinal,
    modalState: false, step: 0, selectedFilial: "", selectedFilialVen: "",
    columnsDatagrid: "", distrA: [], distrB: [], branches: "", consolidatedListA: [],
    consolidatedListB: [], functionStep3: "", rowHeight: 30, validateStep3: "", consolidatedStep4: [],
    modalStep2: false, totalAB: "", modalPendency: false, numTruck: 0,
    dataToReset: [], sugestions: {}, changedTables: false, resetSugestions: false, colorSugestions: false,
    modalOrders: false, sendStep3: false, sendStep4: false, modalPrevious: false, reservBranch: "", reservBranchName: "",
    branch: "", updateStep4: false, message: "", bksChange: false, columns: [], nomeFilial: ""
}

const Distribution = () => {

    const outerTheme = useTheme();
    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(defaultReducer, {
        ...distributionInitialState
    })

    const getDistribution = async () => {
        const body = {
            "dt_inicial": formatDate(state.dtInicial),
            "dt_final": formatDate(state.dtFinal)
        }

        if (state.dtInicial === "" || state.dtFinal === "") {
            toast.error('Preencha todas as datas !')
        } else {

            if (compareDates(formatDate(state.dtInicial), formatDate(state.dtFinal)) === false) {
                toast.error('Data inicial não pode ser maior que a final !')
            } else {
                setLoader(true)
                const res = await api.post('/distribution_elevor/', body)
                if (res.status === 200) {
                    setState({ data: res.data, dataToResetDist: JSON.stringify(res.data) })

                }
                setLoader(false)
            }
        }
    }

    const setInicialDate = (e) => {
        const value = e.format('YYYY-MM-DD')
        setState({ dtInicial: value });
    }

    const setFinalDate = (e) => {
        const value = e.format('YYYY-MM-DD')
        setState({ dtFinal: value });
    }

    const clearAllFilters = () => {
        setState({ dtInicial: "" });
        setState({ dtFinal: "" });
    }

    const openModal = () => {

        if (state.data.length === 0) {
            toast.error('Consulte os dados primeiro para executar !')
        } else {
            setState({ modalState: true })
        }

    }

    const openModalPendency = () => {

        setState({ modalPendency: true })
    }

    const openModalOrders = () => {

        setState({ modalOrders: true })
    }

    const getBranches = async () => {
        setLoader(true)
        const res = await api.get('/distribution_elevor/branches/')

        if (res.status === 200) {

            const uniqueObject = {};

            for (const key in res.data) {
                const id = res.data[key].Cod;
                if (!uniqueObject[id]) {
                    uniqueObject[id] = res.data[key];
                }
            }

            setState({
                branches: uniqueObject
            })
        }
        setLoader(false)

    }

    const getColumns = async () => {
        setLoader(true)
        const body = {
            "dt_inicial": formatDate(state.dtInicial),
            "dt_final": formatDate(state.dtFinal)
        }

        const res = await api.post('/consulta_colunas/', body)
        if (res.status === 200) {
            setState({ columns: res.data })
        }
        setLoader(false)
    }

    const [tableDistribuicao] = TableHookPro()

    useEffect(() => {

        getBranches()
        getColumns()

    }, [])


    window.state = () => {
        console.log(state)
    }

    return (
        <>
            {
                <Box className='distribuicao-main' sx={{ gap: '1rem' }}>
                    <DistributionContext.Provider value={{ state, setState }}>

                        <ExecuteModal />
                        <ModalPendency />
                        <ModalOrders />

                        <ThemeProvider theme={customTheme(outerTheme)}>
                            <Box style={{ display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', borderRadius: '5px', background: 'white', flex: .15 }}>

                                <Box style={{ gap: '1rem', display: 'flex', padding: '1rem 1rem 0 1rem', flexDirection: 'row', justifyContent: 'space-around', width: '32rem' }}>

                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            slotProps={{ textField: { size: 'small' } }}
                                            label="Dt Vendas Inicial:"
                                            size="small"
                                            value={dayjs(state.dtInicial)}
                                            onChange={setInicialDate}
                                            format='DD/MM/YYYY'
                                            dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                        />
                                    </DemoContainer>

                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            slotProps={{ textField: { size: 'small' } }}
                                            label="Dt Vendas Final:"
                                            size="small"
                                            value={dayjs(state.dtFinal)}
                                            onChange={setFinalDate} format='DD/MM/YYYY'
                                            dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                        />
                                    </DemoContainer>

                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '1rem' }}>
                                    <Box style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                                        <ColorButton className='realpadding' onClick={getDistribution}>Consultar</ColorButton>

                                        <ColorButton className='realpadding' onClick={clearAllFilters}>Limpar Filtros</ColorButton>
                                    </Box>

                                    <Box style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>

                                        <ColorButton className='realpadding' onClick={openModalOrders}>Cargas finalizadas</ColorButton>

                                        <ColorButton className='realpadding' onClick={openModalPendency}>Visualizar pendentes</ColorButton>

                                        <ColorButton className='realpadding' onClick={openModal}>Calcular</ColorButton>
                                    </Box>
                                </Box>

                            </Box>

                        </ThemeProvider>

                        <Box sx={{ background: 'white', flex: .85, height: '20rem' }}>
                            <Table
                                key='table-distribution-pro'
                                paginationMode='client'
                                density='compact'
                                className='alterned_grid'
                                rows={state.data}
                                columns={useMemo(() => getColumnsDistribution(state))}
                                rowHeight={30}
                                pro={true}
                                innerRef={tableDistribuicao}
                                nameTable='tableDistributionPRO'
                                hideFooter={true}
                                sx={{
                                    '& .default-app.selected': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    },
                                    height: "100%",
                                    '& .MuiDataGrid-columnHeaderTitleContainer': {
                                        justifyContent: 'center',
                                    },
                                    '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
                                        color: 'black'
                                    }

                                }}
                            />
                        </Box>
                    </DistributionContext.Provider>

                </Box>
            }
        </>)
}

export default Distribution;

